import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21d1b099"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-edit-header-role-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "name" }, "Role"),
  /*#__PURE__*/_createElementVNode("span", { class: "colon" }, ":")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "roles"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseCheckbox = _resolveComponent("BaseCheckbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.isAdmin != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_BaseCheckbox, {
            label: "Administrator",
            checked: _ctx.isAdmin,
            "on-input": _ctx.onToggleAdmin,
            enabled: _ctx.editable,
            "box-color": "dark-gray",
            color: "light-black",
            "color-on-unchecked": "gray",
            "font-size": 13,
            "strikethrough-on-unchecked": true,
            "check-size": 11
          }, null, 8, ["checked", "on-input", "enabled"])
        ]))
      : _createCommentVNode("", true)
  ]))
}